import { render, staticRenderFns } from "./Organisations.vue?vue&type=template&id=707d586a&scoped=true&"
import script from "./Organisations.vue?vue&type=script&lang=js&"
export * from "./Organisations.vue?vue&type=script&lang=js&"
import style0 from "./Organisations.vue?vue&type=style&index=0&id=707d586a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707d586a",
  null
  
)

export default component.exports